import { CoordinatorService } from './coordinator.service';
import { ScriptStage } from './script-stage';

export type STG =
    | 'project'
    | 'databin'
    | 'preview'
    | 'collection'
    | 'stats'
    | 'report'
    | 'book'
    | 'contents'
    | 'page';
export class Stage {
    private _isOff = false;

    constructor(
        public coords: CoordinatorService,
        public tag: STG,
    ) {}

    public get isOff() {
        return this._isOff;
    }
    public set isOff(value) {
        if (this._isOff === value) return;
        this._isOff = value;
        switch (this.tag) {
            case 'databin':
                this.coords.stage$.get('preview')!.isOff = value;
                break;
            case 'preview':
                this.coords.stage$.get('databin')!.isOff = value;
                break;
        }
    }

    is(tag: STG) {
        return this.tag == tag;
    }

    get hasDataset() {
        return this.tag === 'collection' || this.tag === 'preview';
    }

    get isDisplayOn() {
        if (this.isOff) return false;
        if (this.coords.isViewer) return ['project', 'collection', 'stats'].includes(this.tag);
        return this.coords.acl$.isOn(this.tag, 'display');
    }

    setTab(tabId: string) {
        switch (this.tag) {
            case 'project':
                const p$ = this.coords.project$;
                for (const s of p$.sectionLs) {
                    if (s.title.toLowerCase() === tabId) p$.currentSection = s;
                }
                return;
            case 'stats':
                const s$ = this.coords.stats$;
                for (const s of s$.sectionLs) {
                    if (s.title.toLowerCase() === tabId) s$.currentSection$.next(s);
                }
                return;
            case 'report':
                const r$ = this.coords.report$;
                setTimeout(() => r$.setTab$.next(tabId), 300);
        }
        return;
    }

    get scriptClass() {
        return new ScriptStage(this.coords, this);
    }
}
